import { z } from "zod";

import { looseArray } from "~/v2/api/looseParse";

export const positionSchema = z.object({
  asset_id: z.string(),
  symbol: z.string(),
  exchange: z.string(),
  asset_class: z.string(),
  asset_marginable: z.boolean(),
  qty: z.string(),
  avg_entry_price: z.string(),
  side: z.string(),
  market_value: z.string().nullable(),
  cost_basis: z.string(),
  unrealized_pl: z.string().nullable(),
  unrealized_plpc: z.string().nullable(),
  unrealized_intraday_pl: z.string().nullable(),
  unrealized_intraday_plpc: z.string().nullable(),
  current_price: z.string().nullable(),
  lastday_price: z.string().nullable(),
  change_today: z.string().nullable(),
  qty_available: z.string().nullish(),
  name: z.string().nullish(),
  underlying_symbol: z.string().nullish(),
  expires_at: z.string().nullish(),
  intrinsic_value: z.string().nullish(),
  extrinsic_value: z.string().nullish(),
  delta: z.number().nullish(),
  gamma: z.number().nullish(),
  vega: z.number().nullish(),
  theta: z.number().nullish(),
  rho: z.number().nullish(),
  implied_volatility: z.number().nullish(),
});

export type Position = z.infer<typeof positionSchema>;

/** Per-symbol status from the bulk DELETE positions response. */
export const bulkClosePositionStatusSchema = z.object({
  code: z.number(),
  message: z.string().nullish(),
});

export const bulkClosePositionEntrySchema = z.object({
  // Guard falls back to "position" when absent — keep optional.
  symbol: z.string().nullish(),
  status: bulkClosePositionStatusSchema.nullish(),
});

export const bulkClosePositionsResponseSchema = z.object({
  // `.nullish()` preserves null (looseArray alone would coerce null → []).
  statuses: looseArray(
    bulkClosePositionEntrySchema,
    "v3.closePositions.statuses",
  ).nullish(),
});

export type BulkClosePositionsResponse = z.infer<
  typeof bulkClosePositionsResponseSchema
>;
